import { Satisfaction } from 'lib-shared-legacy-types';
import { connect } from 'react-redux';
import { submit } from 'redux-form';

import { languages } from 'app/utils/supportedLanguages';

import actions from '../../../actions/satisfaction';
import { ChatPanel } from '../../../components/sections/satisfaction/components/ChatCSAT/ChatPanel';

import { SatisfactionState } from './../../../reducers/sections/satisfaction';

const {
  satisfactionLoadChatAllLevelsSettingsRequest,
  satisfactionSaveChatGlobalSettingsRequest,
  satisfactionSaveChatLanguageLevelSettingsRequest,
  satisfactionInitializeRequest,
} = actions;

const mapStateToProps = (state: {
  settings: { satisfaction: SatisfactionState };
}) => {
  const {
    globalLevel,
    // contactPointsLevel,
    languagesLevel,
  } = state.settings.satisfaction.customization.widgetchat;

  return {
    globalSettings: globalLevel,
    languagesSettings: {
      list: languages.map(({ code, label }) => {
        const correspondingSettings = languagesLevel.values?.find(
          ({ language }) => language === code,
        );

        if (correspondingSettings) {
          return { code, label, settings: correspondingSettings };
        }

        return { code, label, settings: null };
      }),
      asyncStatus: languagesLevel.asyncStatus,
    },
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    loadSettingsAllLevels() {
      dispatch(satisfactionLoadChatAllLevelsSettingsRequest());
    },
    createGlobalSettings(settings: Satisfaction.CreateChatCsatSettingsParams) {
      const action = satisfactionSaveChatGlobalSettingsRequest(settings, {
        edit: false,
      });
      dispatch(action);
    },
    updateGlobalSettings(settings: Satisfaction.UpdateChatCsatSettingsParams) {
      const action = satisfactionSaveChatGlobalSettingsRequest(settings, {
        edit: true,
      });
      dispatch(action);
    },
    updateLanguageLevelSettings(
      payload: Partial<Satisfaction.ChatCsatSettings>,
    ) {
      const action = satisfactionSaveChatLanguageLevelSettingsRequest(payload);
      dispatch(action);
    },
    initializeChatCsat() {
      dispatch(satisfactionInitializeRequest('widgetchat'));
    },
    submitForm: (formName: string) => dispatch(submit(formName)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ChatPanel);
